(function (root) {
  'use strict';

  // ─── Config ────────────────────────────────────────────────────────────────

  const config = {
    ubembed: {
      origin: 'https://cdaf1c821b5941978b5691b8f96f7ca1.pages.ubembed.com',
      eventName: 'submit_quote_request',
      payload: {},
    },
    customClicks: [
      {
        container: 'shopify-accelerated-checkout, shopify-accelerated-checkout-cart',
        elements: [
          { selector: 'SHOP-PAY-WALLET-BUTTON',    value: 'shop_pay'   },
          { selector: 'SHOPIFY-PAYPAL-BUTTON',     value: 'paypal'     },
          { selector: 'SHOPIFY-GOOGLE-PAY-BUTTON', value: 'google_pay' },
        ],
        eventName: 'click_express_checkout',
        payloadKey: 'event_parameter_level1',
        callback: (containerEl) => {
          if (containerEl.matches('shopify-accelerated-checkout-cart')) {
            const form = containerEl.closest('form');
            if (form) form.dispatchEvent(new Event('submit', { bubbles: true, cancelable: true }));
          }
        },
      },
    ],
  };

  // ─── Helpers ────────────────────────────────────────────────────────────────

  const log = {
    warn: (msg, ...args) => console.warn(`[Tracker] ${msg}`, ...args),
  };

  const helpers = {
    push(event, payload = {}) {
      root.dataLayer = root.dataLayer || [];
      root.dataLayer.push({ ecommerce: null });
      root.dataLayer.push({ event, ...payload });
    },

    parsePayload(raw) {
      try {
        const parsed = JSON.parse(raw);
        return parsed && typeof parsed === 'object' && !Array.isArray(parsed) ? parsed : {};
      } catch {
        log.warn('Invalid JSON in data-track-values:', raw);
        return {};
      }
    },

    isInPath(path, child) {
      return path.includes(child) || path.some(el => el instanceof Node && child.contains(el));
    },
  };

 

  // ─── Custom ─────────────────────────────────────────────────────────────────

  const custom = {
    watchClicks(e) {
      const path = e.composedPath();

      for (const { container, elements, eventName, payloadKey, callback } of config.customClicks) {
        document.querySelectorAll(container).forEach(containerEl => {
          elements.forEach(({ selector, value }) => {
            const child = containerEl.querySelector(selector);
            if (!child || !helpers.isInPath(path, child)) return;
            helpers.push(eventName, { [payloadKey]: value });
            if (typeof callback === 'function') callback(containerEl);
          });
        });
      }
    },

    onFiltersApply() {
      const globalFilteringState = window.filteringState || {};
      const payload = {};
      let paramIndex = 1;

      Object.entries(globalFilteringState).forEach(([name, value]) => {
        if (value == null) return;
        payload[`event_parameter${paramIndex}_level1`] = `${name}`;
        payload[`event_parameter${paramIndex}_level2`] = value?.value ?? `${value?.min}-${value?.max}`;
        paramIndex++;
      });

      helpers.push('apply_filter', payload);
    },

    onVariantChange(e) {
      const { variant } = e.detail || {};
      if (!variant || variant.id === Tracker._lastTrackedVariantId) return;

      Tracker._lastTrackedVariantId = variant.id;
      helpers.push('click_product_condition_variant', { event_parameter_level1: variant.title });
    },

    onMessage(e) {
      const { origin, eventName, payload } = config.ubembed;
      if (e.origin !== origin) return;

      let data;
      try { data = typeof e.data === 'string' ? JSON.parse(e.data) : e.data; }
      catch { return; }

      if (data?.namespace !== 'ub-emb' || data?.type !== 'formSubmit') return;

      helpers.push(eventName, payload);
    },
  };

  // ─── Main ───────────────────────────────────────────────────────────────────

  const main = {
    onClick(e) {
      custom.watchClicks(e);

      const target = e.target;
      const eventEl = target.closest('[data-click-trackable]');
      if (!eventEl) return;

      const event = eventEl.dataset.clickTrackable;
      if (!event) { log.warn('data-click-trackable is empty on element:', eventEl); return; }

      const payloadEl = target.closest('[data-track-values]');
      if (!payloadEl) return;

      const raw = payloadEl.dataset.trackValues.trim();
      helpers.push(event, raw ? helpers.parsePayload(raw) : {});
    },

    onSubmit(e) {
      const formEl = e.target.closest('[data-submit-trackable]');
      if (!formEl) return;

      if (formEl.hasAttribute('data-prevent-submit')) e.preventDefault();

      const event = formEl.dataset.submitTrackable;
      if (!event) { log.warn('data-submit-trackable is empty on element:', formEl); return; }
      if (!('submitValues' in formEl.dataset)) return;

      const raw = formEl.dataset.submitValues.trim();
      const payload = raw ? helpers.parsePayload(raw) : {};

      let isValid = true;

      Object.keys(payload).forEach(key => {
        if (typeof payload[key] === 'string' && payload[key].startsWith('$input:')) {
          const input = formEl.querySelector(`[name="${payload[key].slice(7)}"]`);

          if (key === 'required') {
            if (!input?.value.trim()) isValid = false;
            delete payload[key];
            return;
          }

          payload[key] = input?.value ?? '';
        }
      });

      if (!isValid) return;

      helpers.push(event, payload);
    },
  };

  // ─── Tracker ────────────────────────────────────────────────────────────────

  const Tracker = {
    config,
    helpers,
    _lastTrackedVariantId: null,

    init() {
      document.addEventListener('click',          main.onClick);
      document.addEventListener('submit',         main.onSubmit);
      document.addEventListener('filters:apply',  custom.onFiltersApply);
      document.addEventListener('variant:change', custom.onVariantChange);
      window.addEventListener('message',          custom.onMessage);
    },
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => Tracker.init());
  } else {
    Tracker.init();
  }

  root.Tracker = Tracker;
})(window);